import { easeInOutQuad as animation } from '@opten/animation/ease-in-out-quad';

export function animateCss(
	element: HTMLElement,
	style: string,
	start: number,
	distance: number,
	duration: number,
	complete: Function
) {
	// todo: function in @opten/events?
	let timeStart: number;
	let timeElapsed: number;

	const loop = (time) => {
		timeElapsed = time - timeStart;

		element.style[style] = `${animation(
			timeElapsed,
			start,
			distance,
			duration
		)}px`;

		if (timeElapsed < duration) {
			requestAnimationFrame.call(window, loop);
		} else {
			element.style[style] = `${start + distance}px`;
			complete();
		}
	};

	requestAnimationFrame.call(window, (time) => {
		timeStart = time;
		loop(time);
	});
}
